import {
    addLineItemQuery,
    applyDiscountCodeQuery,
    // associateAddressWithCheckoutQueryV2,
    // associateCustomerWithCheckoutQueryV2,
    createCartQuery,
    getCartQuery,
    removeDiscountCodeQuery,
    updateLineItemQuery,
} from "shopify-queries/storefront/cart";
// import { withAccessToken } from "services/storefront/account";
import { checkoutKey, PMS_URL } from "utils/constants";
import axios from "axios";
import sendLog from "utils/new-relic-logger";
import NEW_RELIC_LEVELS from "constants/NEW_RELIC_LEVELS";
import storefrontQuery from "../common";

export const getCheckoutId = () => localStorage.getItem(checkoutKey);

export const createCheckout = (input) => storefrontQuery(createCartQuery, {
    input: {
        lines: input.lineItems.map((item) => ({
            merchandiseId: item.variantId,
            quantity: item.quantity,
        })),
    },
});

export const getOrCreateCheckoutId = async (init = true, lineItems = []) => {
    const checkoutId = getCheckoutId();
    if ((checkoutId && !lineItems.length) && init) return checkoutId;

    // Don't flip the headless-token flag until we know creation succeeded —
    // otherwise a failure here leaves the storefront in an inconsistent state
    // where subsequent requests use the headless token against a cart that
    // never existed, which loops the user back into this branch on every load.
    const previousUseHeadlessToken = localStorage.getItem("useHeadlessToken");
    localStorage.setItem("useHeadlessToken", true);

    let newCheckout;
    try {
        newCheckout = await createCheckout({ lineItems });
    } catch (err) {
        if (previousUseHeadlessToken === null) {
            localStorage.removeItem("useHeadlessToken");
        } else {
            localStorage.setItem("useHeadlessToken", previousUseHeadlessToken);
        }
        throw err;
    }

    const createdCartId = newCheckout?.data?.cartCreate?.cart?.id;

    if (!createdCartId) {
        if (previousUseHeadlessToken === null) {
            localStorage.removeItem("useHeadlessToken");
        } else {
            localStorage.setItem("useHeadlessToken", previousUseHeadlessToken);
        }

        const cartCreateUserErrors = newCheckout?.data?.cartCreate?.userErrors || [];
        const graphqlErrors = newCheckout?.errors || [];
        const reason = cartCreateUserErrors.length > 0
            ? cartCreateUserErrors.map((ue) => ue?.message || ue?.code).filter(Boolean).join("; ")
            : (graphqlErrors.map((ge) => ge?.message).filter(Boolean).join("; ") || "Empty cartCreate response");

        const error = new Error(`Failed to create Shopify cart: ${reason}`);
        error.name = "CartCreateError";
        // The New Relic logger reads `error.response.data` and
        // `error.response.status`, so attach the GraphQL response there to make
        // the failure observable in production.
        error.response = {
            status: graphqlErrors[0]?.status,
            data: {
                graphqlErrors,
                userErrors: cartCreateUserErrors,
                cartCreate: newCheckout?.data?.cartCreate ?? null,
                lineItemsCount: Array.isArray(lineItems) ? lineItems.length : 0,
            },
        };
        throw error;
    }

    localStorage.setItem(checkoutKey, createdCartId);
    return createdCartId;
};

export const getCheckout = (checkoutId) => storefrontQuery(getCartQuery, { checkoutId });

export const addLineItem = (cartId, lines, properties) => storefrontQuery(addLineItemQuery, {
    cartId, lines, properties,
});

export const updateLineItem = (cartId, lines) => storefrontQuery(updateLineItemQuery, { cartId, lines });

export const applyDiscountCode = (cartId, discountCode) => storefrontQuery(applyDiscountCodeQuery, { cartId, discountCodes: [discountCode] });

export const removeDiscountCode = (checkoutId) => storefrontQuery(removeDiscountCodeQuery, { checkoutId });

// export const associateCustomerWithCheckoutV2 = (checkoutId, customerAccessToken) => storefrontQuery(associateCustomerWithCheckoutQueryV2, { checkoutId, customerAccessToken });

// export const associateAddressWithCheckoutV2 = (checkoutId, shippingAddress) => storefrontQuery(associateAddressWithCheckoutQueryV2, { checkoutId, shippingAddress });

// export const checkoutLoggedInCustomer = async () => {
//     await withAccessToken(async (token) => {
//         const checkoutId = await getOrCreateCheckoutId();
//         const customerAddress = await associateCustomerWithCheckoutV2(checkoutId, token.accessToken);
//         const { defaultAddress } = customerAddress.data.checkoutCustomerAssociateV2.customer;
//         await associateAddressWithCheckoutV2(checkoutId, defaultAddress);
//     });
// };

// export const applyProxyDiscount = async (discountCode, totalOrderPrice) => {
//     const discountData = await axios.get(`${discountProxyURL}?option=check&code=${discountCode}&totalOrderPrice=${totalOrderPrice}`);
//     return discountData?.data || {};
// };

export const applyProxyDiscountV2 = async (cart) => {
    try {
        const response = await axios.post(`${PMS_URL}/checkouts/apply_discount`, { ...cart });

        if (response.status === 200) return response.data;
    } catch (error) {
        sendLog(`[Apply Proxy Discount V2] Error`, NEW_RELIC_LEVELS.ERROR, {
            discountCode: cart?.discountCode || "",
        }, error);
        // eslint-disable-next-line no-console
        console.error(error, "Hello");
    }
    return null;
};
